import React from 'react';

import { isReportState, type StudioRequestSubject } from 'venn-state';
import { Icon } from 'venn-ui-kit';

import { useRecoilValue } from 'recoil';
import { isHistoricalSubject } from 'venn-utils';
import { convertRequestSubjectToItemType } from '../../../../analysis';
import { Block } from '../../core';
import { HistoricalPortfolioStudioHeaderTooltips } from '../historical-portfolio/HistoricalPortfolioStudioHeaderTooltips';
import { Name } from '../legend';

interface InvestmentSubjectProps {
  id: string;
  subject: StudioRequestSubject;
  isColorless?: boolean;
}

export const InvestmentSubject = ({ id, subject, isColorless }: InvestmentSubjectProps) => {
  const props =
    subject.portfolioComparisonType === 'SAVED'
      ? { customIcon: <Icon type="clock-rotate-left" /> }
      : { iconType: convertRequestSubjectToItemType(subject) };

  const isStudio = !useRecoilValue(isReportState);

  return (
    <Block.SubjectsItem {...props} isColorless={isColorless}>
      <Name id={id} subject={subject} isBenchmark={false} />
      {isHistoricalSubject(subject) && isStudio && (
        <HistoricalPortfolioStudioHeaderTooltips blockId={id} subject={subject} isBenchmark={false} />
      )}
    </Block.SubjectsItem>
  );
};
